import api from 'configs/api'
import { format, startOfMonth, endOfMonth } from 'date-fns'

/** Período do mês selecionado: `start=YYYY-MM-DD&end=YYYY-MM-DD` (v2). */
const dateFormated = (value: Date) => {
  const start = format(startOfMonth(value), 'yyyy-MM-dd')
  const end = format(endOfMonth(value), 'yyyy-MM-dd')
  return `start=${start}&end=${end}`
}

export function parseMeRating(raw: unknown): number {
  if (raw === undefined || raw === null) return 0
  const n =
    typeof raw === 'number'
      ? raw
      : Number(String(raw).replace(/\s/g, '').replace(',', '.'))
  if (!Number.isFinite(n) || n < 0) return 0
  return Math.min(5, Math.round(n * 100) / 100)
}

/** Média geral (fixa): campo `rating` em `/doctors/ms/v1/me`. */
export async function fetchDoctorRatingFromMe(): Promise<number> {
  try {
    const { data } = await api.get('/doctors/ms/v1/me')
    return parseMeRating(data?.rating)
  } catch (e) {
    console.error('Erro ao buscar rating em /me:', e)
    return 0
  }
}

export type CsatLoadMeta = {
  commentsCount: number
  period: string
}

/** Comentários e distribuição por mês: CSAT v2 com filtro de datas. */
export const getCsat = async (
  id: string,
  value: Date,
  setRatings: (value: any) => void,
  setComments: (value: string[]) => void,
  setLoading: (value: boolean) => void,
  onLoaded?: (meta: CsatLoadMeta) => void
) => {
  setLoading(true)
  let formattedDate = ''
  try {
    formattedDate = dateFormated(value)
    const { data } = await api.get(
      `rating/ms/v2/csat/doctor/${id}?${formattedDate}`
    )

    setRatings(data?.Rating ?? data?.emotions ?? [])
    const list = Array.isArray(data?.comments) ? data.comments : []
    setComments(list)
    onLoaded?.({
      commentsCount: list.length,
      period: format(value, 'yyyy-MM'),
    })
  } catch (e) {
    console.error(
      `Erro ao buscar CSAT para o ID: ${id} no período ${formattedDate}:`,
      e
    )
  } finally {
    setLoading(false)
  }
}
